import { createPaginateDataGridProvider } from '#shared/components/grid';
import { api, archivedVariantGridTagInvalidator } from '../api/api';

export const useArchivedProductVariantsDataGridProvider = createPaginateDataGridProvider({
    getPageNumber: (params) => params.payload.page ?? 0,
    getPerPage: (params) => params.payload.per_page ?? 25,
    getTotal: (result) => result.total_count,
    getRows: (result) =>
        result.items.map((item) => {
            return {
                id: item.id + '_' + item.product_id,
                attributes: item,
            };
        }),
    getItemFromRow: (row) => row.attributes,
    getSelectableId: (_, rows) => rows.map(({ id }) => id),
    endpoint: api.endpoints.getArchivedVariantsForGrid,
    invalidateTagHelper: archivedVariantGridTagInvalidator,
});
